module.exports = __webpack_public_path__ + "static/media/image1.055e6463.png";